import { dateFormatter as df } from '@cims-online/shared'

/**
 * A singleton DateFormatter instance that localizes dates using the user's system
 * timezone. Use this for all client-side code instead of importing
 * DateFormatter from the shared package.
 *
 * @example
 * dateFormatter.simple(new Date()) // '01/01/2022'
 */
export const dateFormatter = df(null)
